module.exports = __webpack_public_path__ + "img/flag-eastAfrica.d53fa532.png";